import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { Container, Row, Col } from '../../components/ui/Wrapper';
import SectionTitle from '../../components/ui/section-title';
import CaseStudyBox from '../../components/box-large-image/layout-two';
import { Card, CardList, SectionWrap } from './styles';

const UnitList = ({ sectionTitleStyle, caseStudyStyles, slider, sliderStyle }) => {
  const data = useStaticQuery(graphql`
    query {
      unitJson {
        title
        subtitle
        id
        items {
          id
          title
          phone
          image {
            childImageSharp {
              fluid(quality: 100, maxWidth: 480, maxHeight: 298) {
                ...GatsbyImageSharpFluid
                presentationHeight
                presentationWidth
              }
            }
          }
          excerpt
          action {
            label
            path
          }
        }
      }
    }
  `);
  const { title, subtitle, items } = data.unitJson;

  return (
    <SectionWrap>
      <Container>
        <Row>
          <Col lg={12}>
            <SectionTitle {...sectionTitleStyle} title={title} subtitle={subtitle} />
          </Col>
        </Row>
        <CardList>
          {items.map(item => (
            <Card className="item" key={item.id}>
              <CaseStudyBox
                {...caseStudyStyles}
                imageSrc={item.image.childImageSharp}
                title={item.title}
                category={item.phone}
                desc={item.excerpt}
                path={item.action.path}
                btnText={item.action.label}
              />
            </Card>
          ))}
        </CardList>
      </Container>
    </SectionWrap>
  );
};

UnitList.propTypes = {
  sectionTitleStyle: PropTypes.object,
  caseStudyStyles: PropTypes.object,
  slider: PropTypes.object,
  sliderStyle: PropTypes.object,
};

UnitList.defaultProps = {
  sectionTitleStyle: {
    mb: '40px',
    responsive: {
      small: {
        mb: '27px',
      },
    },
  },
  slider: {
    slidesPerView: 2,
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 2,
      },
    },
  },
  sliderStyle: {
    pagination: {
      bottom: 0,
    },
  },
  caseStudyStyles: {
    boxStyle: {
      mt: '20px',
      mb: '35px',
      ml: '15px',
      mr: '15px',
    },
    contentBoxStyle: {
      pt: '25px',
      pl: '26px',
      pr: '26px',
      textalign: 'left',
    },
    headingStyle: {
      as: 'h6',
      fontweight: 600,
      mb: '2px',
    },
    descStyle: {
      mb: 0,
      mt: '13px',
    },
  },
};

export default UnitList;
